var monoPreview = {
  init: ()=> {
    const vm = monoPreview
 
    vm.renderPreviewWidget()
    vm.getProductObj()
    vm.emailDesign()
    personalization.renderText()

    document.querySelector('.button--next').addEventListener('click', vm.nextStep)
    document.querySelector('.button--back').addEventListener('click', vm.prevStep)
  },


  renderPreviewWidget: e => {
    const vm = monoPreview
    const widget = document.getElementById('personalization-widget')

    if (!widget) {
      return false
    }

    // Get the data from API endpoint
    axios.get(COORDINATES_URL, {
      params: {
        shop: 'homebodii-uat.myshopify.com',
        product_id: widget.dataset.product
      }
    })
    .then(function (response) {
      if ('coordinates' in response.data) {
        // Render Coordinates
        vm.getCoordinates(response)
      } 
      
    })
    .catch(function (error) {
      console.log('err', error);
    });
    
  },

  getCoordinates: response => {
    const parent = document.querySelector('.widget-position')

    if (parent.querySelectorAll('.position-option').length == 0) {
      // Get coordinates
      response.data.coordinates.forEach(coordinate => {
        const btn = document.createElement('a')
        btn.classList.add('position-option')
        btn.setAttribute('data-area-code', coordinate.area_code)
        btn.setAttribute('href', 'javascript:void(0)')
        btn.textContent = coordinate.area_name
  
        document.querySelector('.widget-position').appendChild(btn)
      });

      personalization.getOptions()
    }
  },

  getProductObj: e => {
    const vm = personalization
    const widget = document.querySelector('[data-personalization-widget]')
    const handle = widget.dataset.productHandle
    const url = `${window.Shopify.routes.root}products/${handle}.js`

    axios.get(url)
    .then(res => {
      const id = widget.dataset.product
      vm.getVariantOption(res.data, id)
      vm.renderImg(res.data)
      monoPreview.syncVariantSelector()
    })
    .catch(error => {
      console.log('err', error);
    });

  },

  syncVariantSelector: e => {
    const options = document.querySelectorAll('.option-selector__btns input')

    if (!options) {
      return false
    }

    options.forEach(option => {
      option.addEventListener('click', e => {
        const value = e.target.value
        const hidden = document.querySelector('[data-hidden-selector]')

        for (var i = 0; i < hidden.options.length; i++) {
          if (hidden.options[i].label === value) {
            hidden.selectedIndex = i;
            break;
          }
        }
      })
    })

  },

  nextStep: e => {
    const vm = personalization
    const emailBtn = document.querySelector('[data-email-design]')

    if (!emailBtn) {
      return false
    }

    const activePanel = document.querySelector('.tab-panel.active')
    let step = parseInt(activePanel.dataset.step)

    if (step == 4) {
      return false
    }

    if (!personalization.validateSelectedOption()) {
      vm.showErrorMessage({
        errorMsg: 'Please select a position.',
        parent: document.querySelector('.tab-panel[data-step="1"]')
      })
      return false
    } else {
      vm.hideErrorMessage()
    }
    
    // Hide current step
    const currentPanel = document.querySelector(`[data-step="${step}"]`)
    currentPanel.classList.remove('active')

    // Show next step
    const nextStep = step+=1
    const nextPanel = document.querySelector(`[data-step="${nextStep}"]`)
    nextPanel.classList.add('active')

    e.target.style.display = (nextStep == 4) ? 'none' : 'block'
    emailBtn.style.display = (nextStep == 4) ? 'block' : 'none'
  },

  prevStep: () => {
    const nextButton = document.querySelector('.button--next')
    const emailBtn = document.querySelector('[data-email-design]')

    const activePanel = document.querySelector('.tab-panel.active')
    let step = parseInt(activePanel.dataset.step)

    if (step == 1) {
      return false
    }
    
    // Hide current step
    let currentPanel = document.querySelector(`[data-step="${step}"]`)
    currentPanel.classList.remove('active')

    // Show previous step
    let prevStep = step - 1
    const prevPanel = document.querySelector(`[data-step="${prevStep}"]`)
    prevPanel.classList.add('active')

    nextButton.style.display = (prevStep > 3) ? 'none' : 'block'
    emailBtn.style.display = (prevStep == 4) ? 'block' : 'none'
  },

  emailDesign: e => {
    const link = document.querySelector('[data-email-design]')

    if (!link) {
      return false
    }

    link.addEventListener('click', e => {
      let bodyContent = ''

      // axios.get(IMAGE_URL, {
      //   params: {
      //     shop: 'homebodii-uat.myshopify.com',
      //     sample_text: document.querySelector('.personalisation-widget__field--hidden').textContent,
      //     position: document.querySelector('.position-option.active').dataset.areaCode,
      //     product_id: document.querySelector('[data-personalization-widget]').dataset.product,
      //     font: document.getElementById('font-select').value,
      //     colour: document.querySelector('.personalisation-widget__colours a.active').dataset.hexValue
      //   }
      // })
      // .then(function (res) {
      //   bodyContent = res.data.image_url
      // })
      // .catch(function (error) {
      //   console.log('err', error);
      // });

      // Email address and subject
      const email = '';
      const subject = 'Personalisation Preview';
  
      // Encode email and subject
      const encodedEmail = encodeURIComponent(email);
      const encodedSubject = encodeURIComponent(subject);
     
  
      // Construct the mailto URL
      const mailtoUrl = `mailto:${encodedEmail}?subject=${encodedSubject}&body=${bodyContent}`;
      e.target.href = mailtoUrl;
      e.target.click()
    })


  },
}


document.addEventListener('DOMContentLoaded', function() {
  monoPreview.init()
});